// extracted by mini-css-extract-plugin
export default {"emailNotification":"SignUpForm-module__emailNotification___yKYAD","checkbox":"SignUpForm-module__checkbox___o4_Fd"};